import cn from 'classnames';
import { FC } from 'react';
import { FormattedTime } from 'react-intl';

import { TranscriptorEncounterResponse } from '@/shared/api/transcriptor/transcriptorApi';

import { getEncounterDate } from '@/entities/transcriptor';

import styles from '../../Encounters.module.scss';
import { getCallerName } from '../../lib/getCallerName';

type EncounterListItemProps = {
  encounter: TranscriptorEncounterResponse;
  isSelected: boolean;
  onSelect: (encounterId: string) => void;
};

export const EncounterListItem: FC<EncounterListItemProps> = (props) => {
  const { encounter, isSelected, onSelect } = props;

  return (
    <button
      key={encounter.id}
      type="button"
      data-component="encounter-list-item"
      data-id={encounter.id}
      className={cn(styles.item, isSelected && styles.itemSelected)}
      onClick={() => onSelect(encounter.id)}
    >
      <div className={styles.itemTime}>
        <FormattedTime value={getEncounterDate(encounter)} />
      </div>
      <div className={styles.itemName}>{getCallerName(encounter)}</div>
    </button>
  );
};
